import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { CaretDownIcon } from '@phosphor-icons/react';
import styles from './DispensationGroupHeader.module.css';

interface DispensationGroupHeaderProps {
    label: string;
    count: number;
    open: boolean;
    onToggle: () => void;
    children: React.ReactNode;
}

const DispensationGroupHeader: React.FC<DispensationGroupHeaderProps> = ({
    label,
    count,
    open,
    onToggle,
    children,
}) => {
    const { t } = useTranslation();
    const panelId = useId();

    return (
        <div className={styles.group}>
            <div className={styles.headerRow}>
                <button
                    type="button"
                    className={styles.trigger}
                    onClick={onToggle}
                    aria-expanded={open}
                    aria-controls={panelId}
                    aria-label={open ? t('dispensations.collapseGroup', { group: label }) : t('dispensations.expandGroup', { group: label })}
                >
                    <span className={styles.label}>{label}</span>
                    <CaretDownIcon
                        size={20}
                        className={`${styles.icon} ${open ? styles.iconOpen : ''}`}
                        aria-hidden
                    />
                </button>
                <span className={styles.divider} aria-hidden />
                <span className={styles.count}>{t('processings.count', { count })}</span>
            </div>
            <div id={panelId} role="region" aria-label={label} hidden={!open} className={styles.panel}>
                {children}
            </div>
        </div>
    );
};

export default DispensationGroupHeader;
